/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { t } from '@sportninja/common/i18n'
import { Flex } from '../../components/Layout'
import { Mobile } from '../../components/Responsive'
import Text from 'src/components/ts-components/Text'

export const Title = ({ isSeeAllActive, text, onClick, numResults }) => {
  return (
    <Flex
      alignItems='center'
      justifyContent='space-between'
      css={css`
        margin-bottom: 8px;
      `}
    >
      <Text
        variant='paragraphXSmall'
        weight='semiBold'
        color={colors.NEUTRAL_50}
        style={css`
          text-transform: uppercase;
          letter-spacing: 1.6px;
        `}
      >
        {text}{' '}
        {isSeeAllActive &&
          typeof numResults !== 'undefined' &&
          `(${numResults})`}
      </Text>
      {typeof onClick === 'function' && (
        <button
          type='button'
          onClick={onClick}
          css={css`
            color: ${colors.PRIMARY};
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0;

            &:hover {
              text-decoration: underline;
            }
          `}
        >
          <Text
            variant='paragraphXSmall'
            weight='regular'
            color={colors.PRIMARY}
            style={css`
              text-transform: uppercase;
            `}
          >
            {isSeeAllActive ? 'view more' : 'Back'}
          </Text>
        </button>
      )}
    </Flex>
  )
}

const SearchSection = ({
  results,
  onResultClick,
  onSeeAll,
  isSeeAllActive,
  RowComponent,
  titlei18nKey,
  wrapCss = '',
  isFullWidth = false,
  totalResults,
}) => {
  const count = results?.length || 0
  if (count === 0) {
    return false
  }

  return (
    <div
      css={css`
        width: 100%;
        ${wrapCss}
      `}
    >
      <Title
        text={t(
          `common:${titlei18nKey}${
            titlei18nKey !== 'locations' ? '_plural' : ''
          }`,
          { count: 2 }
        )}
        onClick={
          typeof onSeeAll === 'function'
            ? onSeeAll.bind(this, isSeeAllActive)
            : undefined
        }
        isSeeAllActive={isSeeAllActive}
        numResults={totalResults}
      />
      <Mobile>
        {(isMobile) => (
          <div
            className='results-container'
            css={css`
              display: flex;
              flex-direction: column;
              gap: 8px;
            `}
          >
            {results.slice(0, isSeeAllActive ? 3 : count).map((item) => {
              return (
                <RowComponent
                  key={item.id}
                  item={item}
                  onClick={onResultClick}
                  isMobile={isMobile}
                />
              )
            })}
          </div>
        )}
      </Mobile>
    </div>
  )
}

export default SearchSection
